import React from 'react';

import * as I18n from 'circe/I18n';
import ListItem from 'pencil/ListItem';
import { NavLink } from 'react-router-dom';
import ListItemIcon from 'pencil/ListItemIcon';
import ListItemText from 'pencil/ListItemText';
import Equalizer from 'pencil/icons/Equalizer';
import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';
import { ROUTES } from 'domain/finance/payables/constants';

const Sidebar = (props) => {
  const {
    isAllowedMenuItem,
    authorities,
    classes,
    toggleDrawer,
    currentPageTitle,
    setCurrentPageTitle,
    isSidebarItemActive,
    titleMapping,
    open,
  } = props;
  const isSidebarFinance = (match, title) => {
    if (window.location.pathname.startsWith('/finance/reconciliation')) {
      return false;
    }
    return isSidebarItemActive(match, title);
  };
  return (
    <>
      {isAllowedMenuItem('FINANCIAL_DASHBOARD', authorities) && (
        <ItemNavLink
          classes={classes}
          titleMapping={titleMapping}
          toggleDrawer={toggleDrawer}
          isSidebarItemActive={isSidebarFinance}
          open={open}
          toUrl={ROUTES.ROOT}
          itemKey="finance"
          iconComponent={<Equalizer />}
        />
      )}
    </>
  );
};

export default Sidebar;
